import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'

const API = `${process.env.REACT_APP_BACKEND_URL}/api`
const BF = 'Anton, sans-serif'
const MONO = 'JetBrains Mono, monospace'
const SG = 'Space Grotesk, sans-serif'

export default function AdminLogin() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const token = localStorage.getItem('admin_token')
    if (token) {
      fetch(`${API}/admin/verify`, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => { if (r.ok) navigate('/admin/dashboard') })
        .catch(() => {})
    }
  }, [navigate])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const res = await fetch(`${API}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.detail || 'Error al iniciar sesión')
      localStorage.setItem('admin_token', data.token)
      navigate('/admin/dashboard')
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6" style={{ fontFamily: SG }}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md"
      >
        {/* Logo */}
        <div className="text-center mb-12">
          <h1 style={{ fontFamily: BF, fontSize: '48px', color: '#F5A623', letterSpacing: '0.01em' }}>JO.</h1>
          <p className="text-white/30 text-xs tracking-[0.3em] uppercase mt-2" style={{ fontFamily: MONO }}>
            Panel de administración
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-8">
          <div>
            <label className="block text-white/35 text-xs tracking-[0.25em] uppercase mb-3" style={{ fontFamily: MONO }}>
              Usuario
            </label>
            <input
              data-testid="admin-username-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              required
              autoComplete="username"
              className="w-full bg-transparent border-b border-neutral-800 focus:border-amber-400 pb-3 text-white placeholder-white/20 focus:outline-none transition-colors duration-300"
              style={{ fontFamily: SG, fontSize: '17px' }}
            />
          </div>
          <div>
            <label className="block text-white/35 text-xs tracking-[0.25em] uppercase mb-3" style={{ fontFamily: MONO }}>
              Contraseña
            </label>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••"
              required
              autoComplete="current-password"
              className="w-full bg-transparent border-b border-neutral-800 focus:border-amber-400 pb-3 text-white placeholder-white/20 focus:outline-none transition-colors duration-300"
              style={{ fontFamily: SG, fontSize: '17px' }}
            />
          </div>

          {error && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-red-400 text-xs tracking-wider -mt-2"
              style={{ fontFamily: MONO }}
            >
              {error}
            </motion.p>
          )}

          <motion.button
            type="submit"
            disabled={loading}
            data-testid="admin-login-button"
            whileHover={{ x: 4 }}
            whileTap={{ scale: 0.98 }}
            className="self-start flex items-center gap-4 py-3 text-amber-400 hover:text-white transition-colors duration-300 disabled:opacity-40 bg-transparent border-0"
            style={{ fontFamily: MONO, fontSize: '13px', letterSpacing: '0.25em' }}
          >
            <span className="uppercase">{loading ? 'Entrando...' : 'Entrar al panel'}</span>
            <span className="text-xl">↗</span>
          </motion.button>
        </form>

        <div className="mt-16 text-center">
          <a
            href="/"
            className="text-white/20 hover:text-white/50 transition-colors text-xs tracking-[0.2em] uppercase"
            style={{ fontFamily: MONO }}
          >
            ← Volver al portfolio
          </a>
        </div>
      </motion.div>
    </div>
  )
}
